import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getExportFetchURL, getFetchURL } from "../helpers/actionHelpers";
import { getSessionCompanyId } from "../helpers/sessionHelper";
import {editHourEventAsync} from "./reservationSlice";
import PaymentTypeResolver from "../helpers/paymentTypeResolver";

const initialState = {
  paymentTypeLimitedList: [],
  typePriceOfMassageList: [],
  filteredPaymentsList: [],
  paymentTypeList: [],
  paymentObj: {},
  validation: {}
};

export const fetchCalendarMassagePrices = createAsyncThunk(
  "payment/fetchCalendarMassagePrices",
  async ({paymentTypeId, length}, { dispatch }) => {
    const response = await axios.get(getFetchURL(`/massage-type-price/calendar/get/${getSessionCompanyId()}/${paymentTypeId}/${length}`));

    return response.data;
  }
);

export const fetchPassLogPrices = createAsyncThunk(
  "payment/fetchPassLogPrices",
  async (paymentTypeId, { dispatch }) => {
    const response = await axios.get(
      getFetchURL(`/massage-type-price/passlog/get/${getSessionCompanyId()}/` + paymentTypeId)
    );

    return response.data;
  }
);

export const fetchVoucherPrices = createAsyncThunk(
  "payment/fetchVoucherPrices",
  async (paymentTypeId, { dispatch }) => {
    const response = await axios.get(
      getFetchURL(`/massage-type-price/voucher/get/${getSessionCompanyId()}/` + paymentTypeId)
    );

    return response.data;
  }
);

export const fetchPaymentTypes = createAsyncThunk("payment/fetchPaymentTypes", async (_, { dispatch }) => {
  const response = await axios.get(getFetchURL("/payment-type/get"));
  return response.data;
});

export const fetchLimitedPaymentTypes = createAsyncThunk(
  "payment/fetchLimitedPaymentTypes",
  async (_, { dispatch }) => {
    const response = await axios.get(getFetchURL("/payment-type/get-limited"));
    return response.data;
  }
);

export const payBill = createAsyncThunk("payment/payBill", async ({ apiData, exportBill, reservationData }, { dispatch }) => {
  const options = {
    method: "PUT",
    data: apiData,
    headers: { "Content-Type": "application/json" },
    url: getFetchURL("/payment/add")
  };

  const response = await axios(options).then((r) => {
    if (exportBill) {
      exportBillPdf(r.data.billUUID);
    }

    if (reservationData) {
      reservationData.paymentId = r.data.id;
      if (!PaymentTypeResolver.isSlevomat(r.data.paymentType.id)) {
        reservationData.applied = true;
      }

      dispatch(editHourEventAsync(reservationData));
    }

    return r;
  });

  return response.data;
});

export const editBill = createAsyncThunk("payment/editBill", async (apiData, { dispatch }) => {
  const options = {
    method: "PUT",
    data: apiData,
    headers: { "Content-Type": "application/json" },
    url: getFetchURL("/payment/edit")
  };

  const response = await axios(options);
  return response.data;
});

export function exportBillPdf(billUUID) {
  window.open(getExportFetchURL(`/pdf-file/bill/${billUUID}`));
}

export const fetchFilteredPayments = createAsyncThunk(
  "payment/fetchFilteredPayments",
  async (filterText, { dispatch }) => {
    const response = await axios.get(getFetchURL(`/payment/find/${encodeURIComponent(filterText)}`));

    return response.data;
  }
);

export const fetchFilteredPaymentsByBillUUID = createAsyncThunk(
  "payment/fetchFilteredPaymentsByBillUUID",
  async (billUUID, { dispatch }) => {
    const response = await axios.get(getFetchURL(`/payment-reservation/get/${getSessionCompanyId()}/${encodeURIComponent(billUUID)}`));

    return response.data;
  }
);

export const checkFilteredPayments = createAsyncThunk(
  "calendar/checkFilteredPayments",
  async (filterText, { dispatch }) => {
    const response = await axios.get(getFetchURL(`/payment/find/${encodeURIComponent(filterText)}`));

    return response.data;
  }
);

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalendarMassagePrices.fulfilled, (state, action) => {
        state.typePriceOfMassageList = action.payload;
      })
      .addCase(fetchPassLogPrices.fulfilled, (state, action) => {
        state.typePriceOfMassageList = action.payload;
      })
      .addCase(fetchVoucherPrices.fulfilled, (state, action) => {
        state.typePriceOfMassageList = action.payload;
      })
      .addCase(fetchLimitedPaymentTypes.fulfilled, (state, action) => {
        state.paymentTypeLimitedList = action.payload;
      })
      .addCase(payBill.fulfilled, (state, action) => {
        state.paymentObj = action.payload;
      })
      .addCase(editBill.fulfilled, (state, action) => {
        const indexOfElement = state.filteredPaymentsList.findIndex(obj=>obj.id === action.payload.id);
        state.filteredPaymentsList[indexOfElement] = action.payload;
      })
      .addCase(fetchFilteredPayments.fulfilled, (state, action) => {
        state.filteredPaymentsList = action.payload;
      })
      .addCase(fetchFilteredPaymentsByBillUUID.fulfilled, (state, action) => {
        state.filteredPaymentsList = action.payload;
      })
      .addCase(fetchPaymentTypes.fulfilled, (state, action) => {
        state.paymentTypeList = action.payload;
      })
      .addCase(checkFilteredPayments.fulfilled, (state, action) => {
        state.validation.isVoucherNumberValid = action.payload.length === 1;
      });
  }
});

export default paymentSlice.reducer;
